if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cartItemCountBefore = this.getCartItemCount();
        this.limitQuantityToAvailable(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (response.sections) {
                this.updateCart(response, formData.get('id'));
                this.error = false;
                return;
              }

              if (await this.refreshCartContentsIfChanged(formData.get('id'), cartItemCountBefore)) {
                this.error = false;
                return;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) this.updateCart(response, formData.get('id'));
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      updateCart(response, productVariantId) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId, cartData: response });
        this.renderCartContents(response);
      }

      async refreshCartContentsIfChanged(productVariantId, cartItemCountBefore) {
        if (!this.cart || this.cart.tagName !== 'CART-DRAWER') return false;

        try {
          const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
          const cartState = await cartResponse.json();
          if (cartItemCountBefore !== null && cartState.item_count === cartItemCountBefore) return false;

          const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          const sectionsResponse = await fetch(
            `${routes.cart_url}?sections=${sectionIds.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`
          );
          cartState.sections = await sectionsResponse.json();
          cartState.id = productVariantId;
          this.updateCart(cartState, productVariantId);
          return true;
        } catch (error) {
          console.error(error);
          return false;
        }
      }

      getCartItemCount() {
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!bubble) return 0;

        const visibleCount = Number(bubble.querySelector('[aria-hidden="true"]')?.textContent.trim());
        if (Number.isFinite(visibleCount)) return visibleCount;

        const count = bubble.textContent.match(/\d+/);
        return count ? Number(count[0]) : null;
      }

      limitQuantityToAvailable(formData) {
        const quantityInput = this.form.querySelector('[name="quantity"]');
        if (!quantityInput || quantityInput.max === '') return;

        const requestedQuantity = Number(quantityInput.value);
        const availableQuantity = Number(quantityInput.max);
        if (!Number.isFinite(requestedQuantity) || !Number.isFinite(availableQuantity) || requestedQuantity <= availableQuantity) return;

        formData.set('quantity', availableQuantity);
        quantityInput.value = availableQuantity;
        this.handleErrorMessage(window.cartStrings.quantityError.replace('[quantity]', availableQuantity));
      }

      renderCartContents(response) {
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
